module.exports = __webpack_public_path__ + "static/media/image-abu.dfdf6312.png";